import React from 'react'

const Brochure = () => {
  return (
    <div>
      
    </div>
  )
}

export default Brochure
